import "../styles.scss";
import * as React from "react";
import { Button, Icon, Input } from "semantic-ui-react";
import { SOCIAL_NETWORK_METADATA, SocialNetwork } from "../../../../interfaces";

interface InstructionsProps {
  socialNetwork: SocialNetwork;
  playerCardUrl: string;
}

const Instructions: React.FC<InstructionsProps> = ({ socialNetwork, playerCardUrl }) => {
  type Step = {
    description: JSX.Element | string;
    actionText: string;
    action?: () => void;
  };
  var url = new URL(playerCardUrl);
  url.searchParams.set("source", SOCIAL_NETWORK_METADATA[socialNetwork.networkId].key);
  const shareUrl = url.toString();

  const [currentStep, setCurrentStep] = React.useState(0);
  const [steps, setSteps] = React.useState<Step[]>([]);
  React.useEffect(() => {
    setCurrentStep(0);
    const stepOne: Step = {
      description: "Copy your Player Card URL",
      actionText: "Copy",
      action: copyPlayerCardUrl,
    };
    switch (socialNetwork.networkId) {
      case "FB":
        setSteps([
          stepOne,
          {
            description: (
              <span>
                From your Facebook <b>Profile</b> page, click on the <b>About</b> tab, then{" "}
                <b>Contact and basic info</b>, then <b>Add a website</b>
              </span>
            ),
            actionText: "Take Me There!",
            action: () => window.open("https://www.facebook.com/profile.php?sk=about", "_blank"),
          },
          {
            description: (
              <span>
                Paste your Player Card URL into the <b>Website address</b> field and hit <b>Save</b>
              </span>
            ),
            actionText: "Done!",
          },
        ]);

        break;
      case "IG":
        setSteps([
          {
            description: (
              <span>
                From the <b>Profile</b> tab in the Instagram <b>mobile</b> app, click on <b>Edit Profile</b>
              </span>
            ),
            actionText: "Next",
          },
          {
            description: (
              <span>
                Tap on the <b>Link</b> section and then tap <b>Add external link</b>
              </span>
            ),
            actionText: "Next",
          },
          {
            description: (
              <>
                <div>
                  Enter your Player Card URL into the <b>URL</b> field and hit <b>Done</b>
                </div>
                <Input
                  fluid
                  readOnly
                  defaultValue={shareUrl}
                  action={{ color: "primary", icon: "copy outline", onClick: copyPlayerCardUrl }}
                />
              </>
            ),
            actionText: "Done!",
          },
        ]);
        break;
      case "LI":
        const publicData = socialNetwork.publicData ? JSON.parse(socialNetwork.publicData.replaceAll("'", '"')) : {};
        var url: string;
        if (publicData.link) {
          url = `${publicData.link}/edit/forms/contact-info/new/?profileFormEntryPoint=PROFILE_TOP_CARD_EDIT_FORM`;
        } else {
          url = "https://www.linkedin.com/in";
        }
        setSteps([
          stepOne,
          {
            description: (
              <span>
                From your LinkedIn <b>Profile</b> page, click on the <b>pencil icon</b>, then <b>Edit contact info</b>,
                then <b>Add website</b>
              </span>
            ),
            actionText: "Take Me There!",
            action: () => window.open(url, "_blank"),
          },
          {
            description: (
              <span>
                Paste your Player Card URL into the <b>Website URL</b> field and hit <b>Save</b>
              </span>
            ),
            actionText: "Done!",
          },
        ]);
        break;
      case "TW":
        setSteps([
          stepOne,
          {
            description: (
              <span>
                From your X <b>Profile</b> page, click on <b>Edit profile</b>
              </span>
            ),
            actionText: "Take Me There!",
            action: () => window.open("https://x.com/settings/profile", "_blank"),
          },
          {
            description: (
              <span>
                Paste your Player Card URL into the <b>Website</b> field and hit <b>Save</b>
              </span>
            ),
            actionText: "Done!",
          },
        ]);

        break;
      case "TT":
        setSteps([
          stepOne,
          {
            description: (
              <span>
                From your TikTok <b>Profile</b> page, click on <b>Edit profile</b>
              </span>
            ),
            actionText: "Take Me There!",
            action: () => window.open("https://www.tiktok.com/profile", "_blank"),
          },
          {
            description: (
              <span>
                Paste your Player Card URL into the <b>Website</b> field and hit <b>Save</b>{" "}
                <div>(Note: You'll need to convert your account to a business account for this to be available)</div>
              </span>
            ),
            actionText: "Done!",
          },
        ]);

        break;
    }
  }, [socialNetwork.networkId]);

  const copyPlayerCardUrl = () => {
    navigator.clipboard.writeText(shareUrl);
  };

  return (
    <div className="socialMediaInstructions">
      {steps.map((step, index) => {
        const isEnabled = index <= currentStep;
        const isCompleted = index < currentStep;
        const handleActionClick = () => {
          setCurrentStep(index + 1);
          step.action?.();
        };
        return (
          <div key={`step-${index}`} className={`instructionsStep ${isEnabled ? "" : "disabled"}`}>
            <div className="stepNumber">
              <Icon
                name={`${isCompleted ? "check " : ""}circle outline`}
                color={isCompleted ? "green" : "black"}
                size="large"
              />
              <div>Step {index + 1}</div>
            </div>
            <div className="stepDescription">{step.description}</div>
            {<Button primary content={step.actionText || "Next"} onClick={handleActionClick} />}
          </div>
        );
      })}
    </div>
  );
};

export default Instructions;
